import { withState } from 'recompose';

export default withState('params', 'updateParams', {
  name: '',
  status: '',
  email: '',
});
